export const MobileNumberData = () => {
  return <div>Mobile Number</div>;
};
